<!--<div>-->
<!--  @if( !isNew ){-->
<!--    <label>{{ "scale_id" | langVal }}</label>-->
<!--    <app-gen-input isStatic [actualObj]="row" fieldName="scale_id" />-->
<!--  }-->
<!--</div>-->
<div
	[class.new-row]="isNew"
	class="testquestions-tbl"
>
	<div>
		<label>{{ "name" | langVal }}</label>
		<div class="d-flex gap-3 w-100">
			<app-gen-input
				class="w-100"
				[actualObj]="row"
				[errors]="errors"
				fieldName="name"
				title_ph_lang="new_scale_name"
				(changeEvent)="handleChange('name', row.name)"
				(keyupEvent)="validateEntireForm()"
			/>

			@if (isNew) {
			} @else {
				<button
					class="btn btn-icon"
					tabindex="-1"
					(click)="handleDelete(row.id)"
					icon="delete"
				></button>
			}
		</div>
	</div>

	<div class="d-flex test-options">
		<div class="w-50">
			<label>{{ "calculation_method" | langVal }}</label>
			<app-gen-button-group
				[actualObj]="row"
				fieldName="calculation_method"
				optionsListName="calculation_methods"
				title_ph_lang="calculation_method"
				(changeEvent)="
					handleChange('calculation_method', row.calculation_method)
				"
			/>
		</div>

		<div class="w-100">
			<label>{{ "questions" | langVal }}</label>
			<app-testscale-questions-checks
				[value]="row.questions"
				[numedQuestions]="numedQuestions"
				(onUpdate)="handleChange('questions', $event)"
			/>
			@if (errors?.questions) {
				<p class="error">{{ errors.questions }}</p>
			}
		</div>
	</div>

	<div class="interpretation">
		<label class="title">{{ "interpretation" | langVal }}</label>
		<app-testscale-tbl-field
			[value]="row.interpretation"
			(onUpdate)="handleChange('interpretation', $event)"
		/>
	</div>

	<div class="avg_sd">
		<label class="title">{{ "avg_sd" | langVal }}</label>
		<app-testscale-tbl-field
			isAvg
			[value]="row.avg_sd"
			(onUpdate)="handleChange('avg_sd', $event)"
		/>
	</div>

	<div class="remarks">
		<label>{{ "remarks" | langVal }}</label>
		<app-gen-input
			[actualObj]="row"
			fieldName="remarks"
			(changeEvent)="handleChange('remarks', row.remarks)"
		/>
	</div>
	@if (isNew) {
		<div class="d-flex justify-content-end">
			<button
				class="btn btn-primary"
				(click)="handleAddRow()"
				tabClick
				[disabled]="!isFormSubmittable"
			>
				{{ "add" | langVal }}
			</button>
		</div>
	}
	<!-- @else {
  <div class="d-flex justify-content-end">
    <button class="btn btn-icon" tabindex="-1" (click)="handleDelete( row.id )" icon="delete"></button>
  </div>
  } -->
</div>
